"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelPricesContractAdapter = void 0;
const u256_utils_1 = require("../u256-utils");
class FuelPricesContractAdapter {
    constructor(contract, gasLimit) {
        this.contract = contract;
        this.gasLimit = gasLimit;
    }
    async getPricesFromPayload(paramsProvider) {
        return this.extractNumbers(await this.contract.functions
            .get_prices(paramsProvider.getHexlifiedFeedIds().map(u256_utils_1.u256), (await paramsProvider.getPayloadData()))
            .get());
    }
    async writePricesFromPayloadToContract(paramsProvider) {
        return this.extractNumbers(await this.contract.functions
            .write_prices(paramsProvider.getHexlifiedFeedIds().map(u256_utils_1.u256), (await paramsProvider.getPayloadData()))
            .txParams({
            gasLimit: this.gasLimit,
            gasPrice: 1,
        })
            .call());
    }
    async readPricesFromContract(paramsProvider) {
        return this.extractNumbers(await this.contract.functions
            .read_prices(paramsProvider.getHexlifiedFeedIds().map(u256_utils_1.u256))
            .get());
    }
    async readTimestampFromContract() {
        return (await this.contract.functions.read_timestamp().get()).value.toNumber();
    }
    extractNumbers(result) {
        return result.value.map(u256_utils_1.num);
    }
}
exports.FuelPricesContractAdapter = FuelPricesContractAdapter;
//# sourceMappingURL=FuelPricesContractAdapter.js.map